(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-house"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = root => {
    if (root.dataset.ffReady) return;
    root.dataset.ffReady = 'true';
    const journey = root.querySelector('[data-ff-journey]');
    const stage = root.querySelector('.ff-stage');
    const video = root.querySelector('[data-ff-walkthrough]');
    const poster = root.querySelector('.ff-house-poster');
    const header = root.querySelector('.ff-header');
    const sectionLinks = [...root.querySelectorAll('[data-ff-section-link]')];
    const stillFrames = [...root.querySelectorAll('[data-ff-still]')];
    const next = root.querySelector('[data-ff-next]');
    const nextLabel = next.querySelector('[data-ff-next-label]');
    const counter = root.querySelector('[data-ff-counter]');
    const progressBar = root.querySelector('[data-ff-progress]');
    const copies = [...root.querySelectorAll('[data-ff-copy]')];
    const chapters = [...root.querySelectorAll('[data-ff-room]')];
    const motion = root.querySelector('[data-ff-motion]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const on = (el, event, callback, options = {}) => el.addEventListener(event, callback, {...options, signal: controller.signal});
    let paused = Boolean(navigator.connection?.saveData);
    let current = 0;
    let frame = 0;
    let view = true;
    let lastFocus = null;
    let videoReady = false;
    let videoFailed = false;
    let targetTime = 0;
    let seekInFlight = false;
    let lastProgress = 0;
    let mediaPrimed = false;
    let headerHeight = header.offsetHeight;
    let posterIndex = -1;
    let pointerTime = 0;
    let syncDemo = () => {};
    let startDemo = () => {};
    let revealGalleryFrame = () => {};
    let galleryActive = 0;
    let demoObserver;
    const demo = root.querySelector('[data-ff-demo]');
    const clamp = (v, low = 0, high = 1) => Math.max(low, Math.min(high, v));
    const still = () => paused || reduced.matches;
    const setPoster = index => {
      const source = stillFrames.find(el=>Number(el.dataset.ffStill)===index);
      if(!poster || !source || posterIndex===index)return;
      posterIndex=index;
      poster.srcset=source.dataset.srcset;
      poster.src=source.dataset.src;
    };
    const syncNavigation = () => {
      let active=sectionLinks[0];
      sectionLinks.forEach(link=>{
        const section=document.getElementById(link.hash.slice(1));
        if(!section)return;
        const rect=section.getBoundingClientRect();
        if(rect.top<=headerHeight+65 && rect.bottom>headerHeight+65)active=link;
      });
      sectionLinks.forEach(link=>{if(link===active)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');});
    };
    const syncVideo = () => {
      if (!video || !videoReady || videoFailed || seekInFlight || still() || !view) return;
      if (Math.abs(video.currentTime - targetTime) < 1 / 24) return;
      seekInFlight = true;
      try { video.currentTime = targetTime; } catch { seekInFlight = false; }
    };
    const loadVideo = () => {
      if (!video || video.src || videoFailed || still()) return;
      video.muted = true;
      video.src = video.dataset.src;
      video.preload = 'auto';
      video.load();
    };
    const primeVideo = () => {
      loadVideo();
      if (!video || still() || videoFailed || mediaPrimed) return;
      mediaPrimed = true;
      video.play().then(()=>{video.pause();syncVideo();}).catch(()=>{mediaPrimed=false;});
    };
    const showRoom = index => {
      current = clamp(index, 0, 3);
      if(still() || videoFailed)setPoster(current);
      copies.forEach((copy, i) => {
        const visible = i === current;
        if (!visible && copy.contains(document.activeElement)) chapters[current].focus({preventScroll:true});
        copy.classList.toggle('is-active', visible);
        copy.inert = !visible;
        copy.setAttribute('aria-hidden', String(!visible));
        if (!visible) copy.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });
      });
      chapters.forEach((chapter, i) => { if (i === current) chapter.setAttribute('aria-current','step'); else chapter.removeAttribute('aria-current'); });
      nextLabel.textContent = current === 0 ? next.dataset.enter : current === 3 ? next.dataset.finish : next.dataset.next;
      next.href = current === 3 ? '#ff-collection' : '#ff-story';
      counter.textContent = String(current + 1).padStart(2, '0');
    };
    const render = () => {
      frame = 0;
      syncNavigation();
      if (!view) return;
      const distance = Math.max(1, journey.offsetHeight - stage.offsetHeight);
      const progress = still() ? current / 3 : clamp((headerHeight-journey.getBoundingClientRect().top) / distance);
      lastProgress = progress;
      const entering=clamp(progress/.18);
      const finishing=clamp((progress-.82)/.18);
      root.style.setProperty('--ff-scene-scale',String(.86+entering*.155-finishing*.155));
      root.style.setProperty('--ff-scene-yaw',(-5*(1-entering))+'deg');
      root.style.setProperty('--ff-scene-turn',(-1.3*(1-entering))+'deg');
      root.style.setProperty('--ff-scene-border',(12*(1-entering)+7*finishing)+'px');
      root.style.setProperty('--ff-scene-radius',(4+12*finishing)+'px');
      root.style.setProperty('--ff-scene-shadow',String(.14*(1-entering)+.14*finishing));
      root.style.setProperty('--ff-stack-opacity',String(1-entering));
      root.style.setProperty('--ff-video-opacity',String(clamp((progress-.13)/.08)));
      root.style.setProperty('--ff-brand-opacity',String(clamp((progress-.5)/.14)));
      root.style.setProperty('--ff-delivery-opacity',String(finishing));
      showRoom(still() ? current : Math.min(3, Math.floor(progress * 3 + .16)));
      progressBar.style.transform = `scaleX(${progress})`;
      if (poster) poster.style.transform = still() ? 'none' : `scale(${1 + progress * .025})`;
      if (videoReady) {
        targetTime = clamp((progress-.16)/.70) * Math.max(0, video.duration - .08);
        syncVideo();
      }
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(render); };
    const goRoom = i => {
      if (still()) { showRoom(i); schedule(); return; }
      primeVideo();
      const top = window.scrollY + journey.getBoundingClientRect().top-headerHeight;
      window.scrollTo({top:top + Math.max(0, journey.offsetHeight-stage.offsetHeight)*(i/3),behavior:'smooth'});
    };
    const setMotion = () => {
      root.classList.toggle('is-still', still());
      motion.setAttribute('aria-pressed', String(paused || reduced.matches));
      motion.disabled = reduced.matches;
      motion.textContent = reduced.matches ? motion.dataset.reduced : paused ? motion.dataset.resume : motion.dataset.pause;
      if (still()) {video?.pause();setPoster(current);} else {setPoster(0);loadVideo();}
      syncDemo();
      schedule();
    };
    root.classList.add('is-enhanced');
    root.querySelectorAll('.ff-flow-card').forEach(card=>on(card,'toggle',()=>{if(card.open)root.querySelectorAll('.ff-flow-card').forEach(other=>{if(other!==card)other.open=false;});}));
    const gallery=root.querySelector('[data-ff-gallery]');
    if(gallery){
      const cards=[...gallery.querySelectorAll('.ff-flow-card')];
      const previous=root.querySelector('[data-ff-gallery-prev]');
      const forward=root.querySelector('[data-ff-gallery-next]');
      const count=root.querySelector('[data-ff-gallery-index]');
      let galleryIndex=-1;
      const syncGallery=()=>{
        const box=gallery.getBoundingClientRect();
        const center=box.left+box.width/2;
        let nearest=0;
        let distance=Infinity;
        cards.forEach((card,i)=>{const rect=card.getBoundingClientRect();const delta=Math.abs(rect.left+rect.width/2-center);if(delta<distance){nearest=i;distance=delta;}});
        if(nearest===galleryIndex)return;
        galleryIndex=nearest;
        galleryActive=nearest;
        syncDemo();
        count.textContent=String(nearest+1).padStart(2,'0');
        previous.disabled=nearest===0;
        forward.disabled=nearest===cards.length-1;
      };
      const moveGallery=index=>{
        const card=cards[clamp(index,0,cards.length-1)];
        const left=gallery.scrollLeft+card.getBoundingClientRect().left-gallery.getBoundingClientRect().left-parseFloat(getComputedStyle(gallery).paddingLeft);
        gallery.scrollTo({left,behavior:still()?'instant':'smooth'});
      };
      revealGalleryFrame=moveGallery;
      const transform=root.querySelector('[data-ff-transform]');
      if(transform)on(transform,'click',()=>{moveGallery(1);cards[1].open=true;startDemo();});
      on(previous,'click',()=>moveGallery(galleryIndex-1));
      on(forward,'click',()=>moveGallery(galleryIndex+1));
      on(gallery,'scroll',syncGallery,{passive:true});
      on(window,'resize',syncGallery,{passive:true});
      on(gallery,'keydown',event=>{
        if(event.target!==gallery)return;
        const offsets={ArrowRight:galleryIndex+1,ArrowLeft:galleryIndex-1,Home:0,End:cards.length-1};
        if(!(event.key in offsets))return;
        event.preventDefault();moveGallery(offsets[event.key]);
      });
      syncGallery();
    }

    if(demo){
      const demoCard=demo.closest('.ff-flow-card');
      const demoArt=demo.closest('.ff-flow-art');
      const demoToggle=root.querySelector('[data-ff-demo-toggle]');
      let demoVisible=false;
      let demoWanted=false;
      const demoLabel=()=>{demoToggle.textContent=demo.paused?demoToggle.dataset.play:demoToggle.dataset.pause;};
      syncDemo=()=>{
        if(!demoWanted||!demoCard.open||galleryActive!==1||!demoVisible||still()||document.hidden){demo.pause();return;}
        if(!demo.src){demo.src=demo.dataset.src;demo.preload='auto';}
        if(demo.ended)demo.currentTime=0;
        demo.play().catch(demoLabel);
      };
      startDemo=()=>{demoWanted=true;syncDemo();};
      on(demoCard,'toggle',()=>{demoWanted=demoCard.open;if(demoCard.open)revealGalleryFrame(1);syncDemo();});
      on(demoToggle,'click',()=>{demoWanted=demo.paused;syncDemo();});
      on(demo,'loadeddata',()=>demoArt.classList.add('is-demo-ready'));
      on(demo,'play',demoLabel);
      on(demo,'pause',demoLabel);
      on(demo,'ended',()=>{demoWanted=false;demoLabel();});
      on(demo,'error',()=>{demoArt.classList.remove('is-demo-ready');demoLabel();});
      on(document,'visibilitychange',syncDemo);
      demoObserver=new IntersectionObserver(entries=>{demoVisible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.3;syncDemo();},{threshold:.3});
      demoObserver.observe(demoCard);
    }

    if (video) {
      on(video,'loadedmetadata',()=>{
        videoReady = Number.isFinite(video.duration) && video.duration > 0;
        targetTime = clamp((lastProgress-.16)/.70) * Math.max(0, video.duration - .08);
        schedule();
      });
      on(video,'loadeddata',()=>{root.classList.add('is-video-ready');syncVideo();});
      on(video,'seeked',()=>{seekInFlight = false;syncVideo();});
      on(video,'error',()=>{videoFailed = true;seekInFlight = false;root.classList.add('has-video-error');setPoster(current);});
      on(video,'canplay',syncVideo);
      on(journey,'pointerdown',primeVideo,{passive:true});
    }
    setMotion();
    const headerObserver=new ResizeObserver(()=>{headerHeight=header.offsetHeight;root.style.setProperty('--ff-head',headerHeight+'px');schedule();});
    headerObserver.observe(header);
    on(stage,'pointermove',event=>{if(event.pointerType!=='mouse'||still()||performance.now()-pointerTime<32)return;pointerTime=performance.now();const rect=stage.getBoundingClientRect();root.style.setProperty('--ff-look-x',((event.clientX-rect.left)/rect.width-.5)*-.9+'%');root.style.setProperty('--ff-look-y',((event.clientY-rect.top)/rect.height-.5)*-.65+'%');},{passive:true});
    on(stage,'pointerleave',()=>{root.style.setProperty('--ff-look-x','0%');root.style.setProperty('--ff-look-y','0%');});
    on(window,'scroll',schedule,{passive:true});
    on(window,'resize',schedule,{passive:true});
    on(reduced,'change',()=>{const top=window.scrollY+journey.getBoundingClientRect().top-headerHeight;const inside=journey.getBoundingClientRect().top<headerHeight&&journey.getBoundingClientRect().bottom>headerHeight;setMotion();if(inside)window.scrollTo({top,behavior:'instant'});});
    const observer = new IntersectionObserver(entries=>{view=entries[0].isIntersecting;root.classList.toggle('is-in-journey',view);if(view){loadVideo();schedule();}else video?.pause();},{rootMargin:'100px'});
    observer.observe(journey);
    chapters.forEach(button=>on(button,'click',()=>goRoom(Number(button.dataset.ffRoom))));
    on(next,'click',event=>{if(current<3){event.preventDefault();goRoom(current+1);}});
    on(motion,'click',()=>{
      const inside=journey.getBoundingClientRect().top<=headerHeight&&journey.getBoundingClientRect().bottom>headerHeight;
      const top=window.scrollY+journey.getBoundingClientRect().top-headerHeight;
      paused=!paused;
      setMotion();
      if(inside)window.scrollTo({top:top+(still()?0:Math.max(0,journey.offsetHeight-stage.offsetHeight)*(current/3)),behavior:'instant'});
    });
    const requestType = root.querySelector('select[name="contact[Request type]"]');
    const agentNotice = root.querySelector('[data-ff-agent-intent]');
    const syncRequestType = () => { if(agentNotice)agentNotice.hidden=requestType?.value!=='Agent offer'; };
    if(requestType)on(requestType,'change',syncRequestType);
    root.querySelectorAll('[data-ff-plan]').forEach(link=>on(link,'click',()=>{
      const planSelect=root.querySelector('[data-ff-plan-select]');
      const cadenceSelect=root.querySelector('[data-ff-cadence-select]');
      if(planSelect)planSelect.value=link.dataset.ffPlan;
      if(cadenceSelect)cadenceSelect.value=link.dataset.ffCadence;
      if(requestType)requestType.value=link.hasAttribute('data-ff-agent')?'Agent offer':'Project brief';
      syncRequestType();
      if(link.dataset.ffCadence==='monthly'){const optional=root.querySelector('[data-ff-optional]');if(optional)optional.open=true;}
    }));
    root.querySelectorAll('[data-ff-support]').forEach(link=>on(link,'click',()=>{if(requestType)requestType.value='Support';syncRequestType();const optional=root.querySelector('[data-ff-optional]');if(optional)optional.open=true;}));

    const help=root.querySelector('[data-ff-help]');
    if(help){
      const launch=root.querySelector('[data-ff-help-open]');
      const log=help.querySelector('[data-ff-help-log]');
      const question=help.querySelector('[data-ff-help-question]');
      const answers=Object.fromEntries([...help.querySelectorAll('[data-answer]')].map(el=>[el.dataset.answer,el.textContent.trim()]));
      const rates=Object.fromEntries([...root.querySelectorAll('[data-ff-package]')].map(el=>[el.dataset.ffPackage,el.dataset.price]));
      const bubble=(text,user=false)=>{const p=document.createElement('p');p.className='ff-help-bubble'+(user?' is-user':'');p.textContent=text;log.append(p);while(log.children.length>30)log.firstElementChild.remove();log.scrollTop=log.scrollHeight;};
      const reply=topic=>{let text=answers[topic]||answers.fallback;Object.entries(rates).forEach(([k,v])=>{text=text.replaceAll('['+k+']',v);});bubble(text);};
      const closeHelp=help.querySelector('[data-ff-help-close]');
      let helpDestination=null;
      const openHelp=()=>{help.showModal();launch.setAttribute('aria-expanded','true');if(!log.children.length)reply('hello');closeHelp.focus({preventScroll:true});};
      on(launch,'click',openHelp);
      on(closeHelp,'click',()=>help.close());
      on(help,'click',event=>{if(event.target===help){const rect=help.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)help.close();}});
      on(help,'close',()=>{launch.setAttribute('aria-expanded','false');(helpDestination||launch).focus({preventScroll:true});helpDestination=null;});
      help.querySelectorAll('[data-ff-help-route]').forEach(link=>on(link,'click',()=>{helpDestination=root.querySelector('#ff-brief input[name="contact[name]"]');help.close();}));
      const supportForm=help.querySelector('form[action]');
      if(supportForm && location.hash==='#'+supportForm.id && supportForm.querySelector('[role="status"],[role="alert"]')){openHelp();help.querySelector('[data-ff-help-contact]').open=true;}
      help.querySelectorAll('[data-ff-topic]').forEach(button=>on(button,'click',()=>{bubble(button.textContent,true);reply(button.dataset.ffTopic);}));
      const rules=[['prices',/price|cost|offer|deal|package|discount|monthly|precio|oferta|paquete|mensual|سعر|اسعار|بكام|عرض|عروض|باقة|باقه|دولار/],['delivery',/deliver|when|turnaround|ready|urgent|entrega|cuando|plazo|تسليم|امتى|موعد|وقت/],['revisions',/revision|change|edit|revis|cambio|تعديل|تعديلات/],['formats',/format|vertical|landscape|instagram|reel|tiktok|horizontal|مقاس|طولي|عرضي|ريل|انست/],['photos',/photo|image|picture|upload|send|foto|imagen|enviar|صور|صورة|ارفع|ابعت/],['service',/service|work|visit|shoot|company|about|servicio|funciona|visita|empresa|خدمة|خدمه|شركة|شركه|زيارة|زياره|تصوير/],['hello',/^(hi|hello|hey|hola|مرحبا|اهلا|السلام عليكم)[! .]*$/]];
      on(help.querySelector('[data-ff-help-form]'),'submit',event=>{event.preventDefault();const text=question.value.trim();if(!text)return;bubble(text,true);question.value='';const normalized=text.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[أإآ]/g,'ا');const topic=rules.find(([,pattern])=>pattern.test(normalized))?.[0];reply(topic||'fallback');if(!topic){const contact=help.querySelector('[data-ff-help-contact]');contact.open=true;const field=help.querySelector('[data-ff-help-message]');if(field)field.value=text;}question.focus();});
    }

    const dialog=root.querySelector('[data-ff-dialog]');
    const player=root.querySelector('[data-ff-player]');
    root.querySelectorAll('[data-ff-play]').forEach(button=>on(button,'click',()=>{
      const url=player.dataset.videoUrl;
      if(!url)return;
      lastFocus=button;
      const video=document.createElement('video');
      video.src=url;
      video.controls=true;
      video.playsInline=true;
      video.preload='metadata';
      video.setAttribute('aria-label',player.dataset.title);
      if(player.dataset.poster)video.poster=player.dataset.poster;
      player.replaceChildren(video);
      dialog.showModal();
      video.play().catch(()=>{});
      root.querySelector('[data-ff-close]').focus();
    }));
    on(root.querySelector('[data-ff-close]'),'click',()=>dialog.close());
    on(dialog,'click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
    on(dialog,'close',()=>{const video=player.querySelector('video');if(video){video.pause();video.removeAttribute('src');video.load();}player.replaceChildren();lastFocus?.focus();});
    on(document,'shopify:section:unload',event=>{if(event.target.contains(root)){controller.abort();observer.disconnect();headerObserver.disconnect();demoObserver?.disconnect();if(demo){demo.pause();demo.removeAttribute('src');demo.load();}if(frame)cancelAnimationFrame(frame);if(video){video.pause();video.removeAttribute('src');video.load();}}});
    schedule();
  };
  document.querySelectorAll('[data-ff-house]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ff-house]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
